'use client'
import { Button } from '@/components/ui/button'
import { Heart } from 'lucide-react'
import {
  useWishlistTotal,
  withWishListSuspense,
} from '../../wishlist-products/wishlist.provider'
import { useAuthDialogStore } from '../../auth-forms/auth-dialog.store'
import { useSession } from '@/lib/queries/session'
import { useRouter } from 'next/navigation'

const WishlistButton = () => {
  const total = useWishlistTotal()
  const wishlistUrl = '/wishlist'
  const toggleShowDialog = useAuthDialogStore()((s) => s.toggleShowDialog)
  const { data: session } = useSession()
  const router = useRouter()

  const onClick = () => {
    session ? router.push(wishlistUrl) : toggleShowDialog()
  }

  return (
    <Button
      onClick={onClick}
      variant={'plain'}
      size={'plain'}
      className="relative"
    >
      <Heart strokeWidth={1} className="size-6 text-black" />
      {total > 0 && (
        <span className="absolute -bottom-0.5 -right-1 flex size-4 items-center justify-center rounded-full bg-secondary-900 text-2xs text-secondary-50">
          {total}
        </span>
      )}
    </Button>
  )
}

export default withWishListSuspense(WishlistButton)
